<template>
  <FormBox :title="$t('hzmbChange.title.vehicle')" style="background: #fff">
    <span class="title-tips">{{ $t("hzmbChange.title.vehicle_tips") }}</span>
    <el-form
      ref="ruleForm"
      :model="form.vehicle"
      class="form_type1_box"
      :rules="vehicleRules"
      hide-required-asterisk
    >
      <el-row :gutter="86" type="flex">
        <el-col v-if="!isChangeDriver" :xs="24" :sm="24">
          <el-form-item
            :label="$t('hzmbChange.label.registrationNo')"
            prop="regAndIdNo"
          >
            <el-input
              :placeholder="$t('hzmbChange.message.registNoAndIdNo_plh')"
              ref="registrationNo"
              v-model="form.vehicle.regAndIdNo"
              class="input-with-select"
              @focus="onRegistNoFocus"
              maxlength="8"
            ></el-input>
          </el-form-item>
          <div class="tips_red">{{ $t("message.registrationNo_tips") }}</div>
        </el-col>
        <!-- 分割线 -->
        <template v-if="!isChangeDriver || (isChangeDriver && form.renew)">
          <el-col :xs="24" :sm="24">
            <el-divider>{{ $t("hzmbChange.title.hk_vehicle") }}</el-divider>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item
              :label="$t('hzmbChange.label.hkInsuranceCompany')"
              prop="vehicleInsuranceCompanyNoHk"
            >
              <el-input
                v-model="form.vehicle.vehicleInsuranceCompanyNoHk"
                :placeholder="$t('hzmbChange.message.hkInsuranceCompany_plh')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item
              :label="$t('hzmbChange.label.hkInsuranceNo')"
              prop="vehicleInsuranceNoHk"
            >
              <el-input
                v-model="form.vehicle.vehicleInsuranceNoHk"
                :placeholder="$t('hzmbChange.message.hkInsuranceNo_plh')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item
              :label="$t('hzmbChange.label.hkInsuranceStartDate')"
              prop="vehicleInsuranceStartDateHk"
            >
              <el-date-picker
                v-model="form.vehicle.vehicleInsuranceStartDateHk"
                type="date"
                :placeholder="$t('hzmbChange.message.hkInsuranceStartDate_plh')"
                format="dd/MM/yyyy"
                value-format="yyyy-MM-dd"
                :picker-options="checkHKInsuranceStartDate"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item
              :label="$t('hzmbChange.label.hkInsuranceEndDate')"
              prop="vehicleInsuranceEndDateHk"
            >
              <el-date-picker
                v-model="form.vehicle.vehicleInsuranceEndDateHk"
                type="date"
                :placeholder="$t('hzmbChange.message.hkInsuranceEndDate_plh')"
                format="dd/MM/yyyy"
                value-format="yyyy-MM-dd"
                :picker-options="checkHKInsuranceEndDate"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </template>
        <!-- 分割线 -->
        <el-col :xs="24" :sm="24">
          <el-divider>{{ $t("hzmbChange.title.mainland_vehicle") }}</el-divider>
        </el-col>
        <el-col v-if="hasChangeVehicle" :xs="24" :sm="12">
          <el-form-item
            :label="$t('hzmbChange.label.mainlandRegistrationNo')"
            prop="plateNoCn"
          >
            <el-input
              v-model="form.vehicle.plateNoCn"
              :placeholder="$t('hzmbChange.message.mainlandRegistrationNo_plh')"
            >
              <template slot="prepend">粤</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item
            :label="$t('hzmbChange.label.mainlandInsuranceNo')"
            prop="vehicleInsuranceNoCn"
          >
            <el-input
              v-model="form.vehicle.vehicleInsuranceNoCn"
              :placeholder="$t('hzmbChange.message.mainlandInsuranceNo_plh')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item
            :label="$t('hzmbChange.label.mainlandInsuranceStartDate')"
            prop="vehicleInsuranceStartDateCn"
          >
            <el-date-picker
              v-model="form.vehicle.vehicleInsuranceStartDateCn"
              type="date"
              :placeholder="
                $t('hzmbChange.message.mainlandInsuranceStartDate_plh')
              "
              format="dd/MM/yyyy"
              value-format="yyyy-MM-dd"
              :picker-options="checkMainlandInsuranceStartDate"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item
            :label="$t('hzmbChange.label.mainlandInsuranceEndDate')"
            prop="vehicleInsuranceEndDateCn"
          >
            <el-date-picker
              v-model="form.vehicle.vehicleInsuranceEndDateCn"
              type="date"
              :placeholder="
                $t('hzmbChange.message.mainlandInsuranceEndDate_plh')
              "
              format="dd/MM/yyyy"
              value-format="yyyy-MM-dd"
              :picker-options="checkMainlandInsuranceEndDate"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- 註冊編號和車身編號彈窗 -->
    <RegistrationNoDialog
      v-if="showRegistrationNoDialog"
      @save="registNoSave"
      @close="showRegistrationNoDialog = false"
    ></RegistrationNoDialog>
  </FormBox>
</template>

<script>
import i18n from "/public/lang/index";
import FormBox from "../../../components/FormBox.vue";
import RegistrationNoDialog from "@/components/RegistrationNoDialog.vue";
export default {
  props: {
    form: {
      type: Object,
      default: () => {
        return {
          vehicle: {},
        };
      },
    },
  },
  components: { FormBox, RegistrationNoDialog },
  data() {
    let mainlandInsuranceEndDateCheck = (rule, value, callback) => {
      const today = new Date();
      today.setHours(0, 0, 0, 0); // 確保比較的是日期部分，不包含時間
      const selectedDate = new Date(value);
      if (selectedDate < today) {
        callback(
          new Error(i18n.t("hzmbChange.message.mainlandInsuranceEndDateCheck"))
        );
      } else {
        callback();
      }
    };
    return {
      beforeToday: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //如果没有后面的-8.64e6就是不可以选择今天
        },
      },
      // 香港保險單生效日期範圍
      checkHKInsuranceStartDate: {
        disabledDate: (time) => {
          const vehicleInsuranceEndDateHk =
            this.form.vehicle.vehicleInsuranceEndDateHk;
          if (vehicleInsuranceEndDateHk) {
            return (
              time.getTime() > new Date(vehicleInsuranceEndDateHk).getTime()
            );
          }
        },
      },
      // 香港保險單結束日期範圍
      checkHKInsuranceEndDate: {
        disabledDate: (time) => {
          const vehicleInsuranceStartDateHk =
            this.form.vehicle.vehicleInsuranceStartDateHk || null;
          const date = new Date();
          let myDate =
            vehicleInsuranceStartDateHk &&
            new Date(vehicleInsuranceStartDateHk) > date
              ? new Date(vehicleInsuranceStartDateHk)
              : date;
          return time.getTime() < myDate.getTime() - 1 * 24 * 60 * 60 * 1000;
        },
      },
      // 內地保險單生效日期範圍
      checkMainlandInsuranceStartDate: {
        disabledDate: (time) => {
          const vehicleInsuranceEndDateCn =
            this.form.vehicle.vehicleInsuranceEndDateCn;
          if (vehicleInsuranceEndDateCn) {
            return (
              time.getTime() > new Date(vehicleInsuranceEndDateCn).getTime()
            );
          }
        },
      },
      // 內地保險單結束日期範圍
      checkMainlandInsuranceEndDate: {
        disabledDate: (time) => {
          const vehicleInsuranceStartDateCn =
            this.form.vehicle.vehicleInsuranceStartDateCn || null;
          let myDate =
            vehicleInsuranceStartDateCn &&
            new Date(vehicleInsuranceStartDateCn);
          return (
            myDate &&
            time.getTime() < myDate.getTime() - 1 * 24 * 60 * 60 * 1000
          );
        },
      },
      vehicleRules: {
        identificationNo: [
          {
            max: 30,
            message: i18n.t("hzmbChange.message.maxLength", [30]),
            trigger: "blur",
          },
        ],
        vehicleInsuranceNo: [
          {
            max: 50,
            message: i18n.t("hzmbChange.message.maxLength", [50]),
            trigger: "blur",
          },
        ],
        vehicleInsuranceStartDate: [],
        vehicleInsuranceEndDate: [],
        vehicleInsuranceCompanyNoHk: [
          {
            required: true,
            message: i18n.t("hzmbChange.message.notNull"),
            trigger: "blur",
          },
          {
            max: 100,
            message: i18n.t("hzmbChange.message.maxLength", [100]),
            trigger: "blur",
          },
        ],
        vehicleInsuranceNoHk: [
          {
            required: true,
            message: i18n.t("hzmbChange.message.notNull"),
            trigger: "blur",
          },
          {
            max: 50,
            message: i18n.t("hzmbChange.message.maxLength", [50]),
            trigger: "blur",
          },
        ],
        vehicleInsuranceStartDateHk: [
          {
            required: true,
            message: i18n.t("hzmbChange.message.dateRequired"),
            trigger: "change",
          },
        ],
        vehicleInsuranceEndDateHk: [
          {
            required: true,
            message: i18n.t("hzmbChange.message.dateRequired"),
            trigger: "change",
          },
        ],
        vehicleInsuranceNoCn: [
          {
            required: true,
            message: i18n.t("hzmbChange.message.notNull"),
            trigger: "blur",
          },
          {
            max: 50,
            message: i18n.t("hzmbChange.message.maxLength", [50]),
            trigger: "blur",
          },
        ],
        vehicleInsuranceStartDateCn: [
          {
            required: true,
            message: i18n.t("hzmbChange.message.dateRequired"),
            trigger: "change",
          },
        ],
        vehicleInsuranceEndDateCn: [
          {
            required: true,
            message: i18n.t("hzmbChange.message.dateRequired"),
            trigger: "change",
          },
          { validator: mainlandInsuranceEndDateCheck, trigger: "change" },
          { validator: mainlandInsuranceEndDateCheck, trigger: "blur" },
        ],
        plateNoCn: [
          {
            max: 20,
            message: i18n.t("hzmbChange.message.maxLength", [20]),
            trigger: "blur",
          },
        ],
        regAndIdNo: [
          {
            required: true,
            message: i18n.t("hzmbChange.message.notNull"),
          },
          {
            max: 8,
            message: i18n.t("hzmbChange.message.maxLength", [8]),
            trigger: "blur",
          },
        ],
      },
      registrationNoType: "1",
      showRegistrationNoDialog: false,
      registNoForm: {},
      registNoRules: {
        registrationNo: [
          {
            required: true,
            message: i18n.t("hzmbChange.message.notNull"),
            trigger: "blur",
          },
          {
            max: 20,
            message: i18n.t("hzmbChange.message.maxLength", [20]),
            trigger: "blur",
          },
        ],
        identificationNo: [
          {
            required: true,
            message: i18n.t("hzmbChange.message.notNull"),
            trigger: "blur",
          },
        ],
        captcha: [
          {
            required: true,
            message: i18n.t("hzmbChange.message.notNull"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    serviceType() {
      return this.$route.params.serviceType;
    },
    isChangeDriver() {
      return this.form.changeType === "CHANGE_DRIVER";
    },
    hasChangeVehicle() {
      const { changeType } = this.form;
      return ["CHANGE_VEHICLE", "CHANGE_VEHICLE_DRIVER"].includes(changeType);
    },
    isGHCompany() {
      return this.serviceType === "HZMB_GH_CHANGE_COMP";
    },
  },
  methods: {
    // 子組件校驗，傳到父組件
    validateForm() {
      let flag = null;
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          flag = true;
        } else {
          flag = false;
        }
      });
      return flag;
    },
    // 關閉註冊編號彈窗
    handleClose() {
      this.showRegistrationNoDialog = false;
    },
    // 車輛的註冊編號儲存
    registNoSave(data) {
      this.form.vehicle.identificationNo = data.identificationNo;

      const registrationNo = data.registrationNo;
      this.$set(this.form.vehicle, "regAndIdNo", registrationNo);
      this.$set(this.form.vehicle, "registrationNo", registrationNo);
      this.showRegistrationNoDialog = false;
    },
    // 驗證車身註冊編號弹窗
    onRegistNoFocus() {
      this.$refs["registrationNo"].blur();
      this.showRegistrationNoDialog = true;
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.input-with-select {
  /deep/.el-input-group__prepend {
    width: auto;
    padding: 0;
  }
  /deep/.el-input-group__prepend .el-select {
    margin: -12px 0px;
  }
  /deep/.el-form-item.is-error .el-input-group__prepend .el-input__inner {
    border-color: transparent !important;
  }
}
.identificationNo_tips {
  color: #38959d;
  margin-bottom: 12px;
  line-height: 25px;
}
.identificationNo_mark {
  color: #38959d;
  margin: 12px 0;
  line-height: 25px;
}
/deep/.el-divider--horizontal {
  margin: 10px 0;
  .el-divider__text {
    color: #c0c4cc;
  }
}
</style>

<style>
.m-tooltip-popper {
  max-width: 500px;
  width: 80%;
}
</style>
